<template>
  <section class="fshr-mapItemTooltip-vue">
    <section v-if="url">
      <a
        :href="url"
        class="fshr-mapItemTooltip"
        :class="{ 'fshr-mapItemTooltip--noImage': !content.imageSrc }"
        target="_blank"
      >
        <HotelMarkerDetailsInner :content="content" />
      </a>
    </section>
    <section v-if="!url">
      <div
        class="fshr-mapItemTooltip"
        :class="{ 'fshr-mapItemTooltip--noImage': !content.imageSrc }"
      >
        <HotelMarkerDetailsInner :content="content" />
      </div>
    </section>
  </section>
</template>

<script>
import HotelMarkerDetailsInner from "./HotelMarkerDetailsInner.vue";

export default {
  name: "HotelMarkerDetails",
  components: {
    HotelMarkerDetailsInner,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: false,
    },
  },
};
</script>
